export default function UserEducation({ openModal, educations, degrees, lang }: any) {
  const getDegreesName = (id: number) =>
    degrees.find((i: any) => i.id == id)?.name || "-";

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Pendidikan" : "Education"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("education")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {educations.map((exp: any, idx: number) => (
        <div key={idx} className="p-2 rounded-xl border-2">
          <h4 className="text-lg font-semibold">{exp.univTitle}</h4>
          <p className="text-sm">{exp.univMajor}</p>
          <p className="text-sm">{getDegreesName(exp.univDegree)}</p>
          <p className="text-sm text-gray-500">
            {lang === "id"
              ? `${exp.startDate} – ${exp.current ? "Sekarang" : exp.endDate || "-"}`
              : `${exp.startDate} – ${exp.current ? "Present" : exp.endDate || "-"}`
            }
          </p>
        </div>
      ))}
    </div>
  );
}
